import css from 'styled-jsx/css';
import { theme } from '@admitkard/ccl/style';

export const UniversityCardCss = css`
  .univ-card {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    box-shadow: ${theme.shadows[2]};
    border-radius: ${theme.shape.borderRadiusS};
    margin: ${theme.spacingOld(3)} 0;
    background-color: rgba(255, 248, 235, 1);
    padding: ${theme.spacingOld(6)} ${theme.spacingOld(3)} ${theme.spacingOld(3)};
    width: 100%;
    z-index: 0;
  }

  .univ-card-top {
    display: flex;
    align-items: center;
    position: relative;
    padding: ${theme.spacingOld(2)} 0;
  }

  .univ-card-bottom {
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  .rank-container {
    position: absolute;
    right: 0em;
    top: -1em;
    align-self: flex-start;
    margin-left: ${theme.spacingOld(3)};
  }

  .univ-name-container {
    min-width: 15rem;
  }

  .univ-details {
    display: flex;
    align-items: center;
    max-width: 30rem;
  }

  .univ-state-container {
    display: flex;
    align-items: center;
  }

  .margin-left-2 {
    margin-left: ${theme.spacingOld(2)};
  }

  @media ${theme.mediaQuery.tabletUp} {
    .univ-card {
      flex-direction: row;
      padding: ${theme.spacingOld(4)} ${theme.spacingOld(6)};
    }
    .rank-container {
      position: unset;
      margin-left: auto;
      min-width:10rem;
    }
    .univ-name-container {
      max-width: 20rem;
    }
    .univ-details {
      display: flex;
      align-items: center;
      min-width: 32rem;
    }
  }
`;
